// src/components/DashboardLayout.js
import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { useToast } from "../../contexts/ToastContext";
import { apiRequest } from "../../services/api";
import Loader from "../Common/Loader";
import { Breadcrumb } from "react-bootstrap";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { encryptData } from "../Common/encryptionUtils";
import Shimmer from "../Common/Shimmer";
import "./Users.css";
import { AccessLog } from "../../Utils/AccessLog";
import InStatusImage from "../../assets/OnlineLoading_withBg.gif";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Avatar,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  Pagination,
} from "@mui/material";
import Switch from "react-switch";
import * as Yup from "yup";

import showPasswordIcon from "../../assets/ph_eye.png"; // 👁️ icon
import hidePasswordIcon from "../../assets/eye.png"; // 🙈 icon

const Users = () => {
  useEffect(() => {
    AccessLog("Users");
  }, []);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const pageLoading = (data) => {
    setLoading(data);
  };

  const [activeMenu, setActiveMenu] = useState(null);
  const [showModal, setShowModal] = useState(false); // Track modal visibility
  const [showUploadModal, setShowUploadModal] = useState(false); // Track modal visibility
  const [userToDelete, setUserToDelete] = useState(null);
  const [userToStatusAction, setUserToStatusAction] = useState(null);
  const [userRemoveData, setUserRemoveData] = useState(null);
  const [userStatus, setUserStatus] = useState(null);
  const [userAction, setUserAction] = useState(null);
  const [policyList, setPolicyList] = useState([]);

  const handleRemoveUser = (userData, status, action) => {
    setUserToDelete(userData);
    setUserStatus(status);
    setUserAction(action);
    setShowModal(true);
    // Add your remove logic here
  };

  const handleUserStatus = (userData, status, action) => {
    // handleUserStatusAPI(userData, status);
    setUserToStatusAction(userData);
    setUserStatus(status);
    setUserAction(action);
    setShowModal(true);
    // Add your remove logic here
  };

  const handleRemoveUserData = (userData, status, action) => {
    // handleUserStatusAPI(userData, status);
    setUserRemoveData(userData);
    setUserStatus(status);
    setUserAction(action);
    setShowModal(true);
    // Add your remove logic here
  };

  const toggleMenu = (premiseId) => {
    setActiveMenu(activeMenu === premiseId ? null : premiseId);
  };

  // Confirm delete and call API
  const confirmDelete = () => {
    if (userToDelete) {
      handleRemoveUserAPI(userToDelete, userStatus);
      setShowModal(false);
      setUserToDelete(null);
      setUserStatus(null);
    }
    if (userToStatusAction) {
      handleUserStatusAPI(userToStatusAction, userStatus);
      setShowModal(false);
      setUserToStatusAction(null);
      setUserStatus(null);
    }
    if (userRemoveData) {
      handleRemoveUserInPremiseAPI(userRemoveData, userStatus);
      setShowModal(false);
      setUserToStatusAction(null);
      setUserStatus(null);
    }
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setUserToDelete(null);
  };

  const fetchAllPolicies = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/getTimeOffPolicy?created_by=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data?.timeoff_policy_data
      ) {
        const policy_details = policyResponse.data?.data?.timeoff_policy_data;
        setPolicyList(policy_details);
      } else {
        setPolicyList([]);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const authToken = localStorage.getItem("authToken");

  const handleRemoveUserAPI = async (userData, userStatus) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        phone_number: encryptData(userData?.user_phone_number),
        status: encryptData(userStatus),
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
      };

      const deleteUser = await apiRequest(
        `api/user/activateDeactivateAccount`,
        "POST",
        payload,
        headers
      );

      if (deleteUser?.data?.status_code === 200) {
        const policy_details = deleteUser.data;
        setLoading(false);
        setActiveMenu(null);
        fetchAlluser(selectedTopBarPremises?.value);
        // navigate("/users");
        toast.success(policy_details?.data?.all, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Handle API response with errors or non-200 status codes
        const errorMessage =
          deleteUser?.data?.message || "Something went wrong.";
        setLoading(false);
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      // Handle network or unexpected errors
      // console.error('Error while creating policy:', error);
      toast.error("Failed to delete premises. Please try again later.", {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const handleUserStatusAPI = async (userData, status) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        user_id: encryptData(userData?.user_id?.toString()),
        status: encryptData(status),
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        mobile_number: encryptData(userData?.user_phone_number?.toString()),
      };

      const deleteUser = await apiRequest(
        `api/user/updateuserstatus`,
        "PUT",
        payload,
        headers
      );

      if (deleteUser?.data?.status_code === 200) {
        const policy_details = deleteUser.data;
        setLoading(false);
        setActiveMenu(null);
        fetchAlluser(selectedTopBarPremises?.value);
        toast.success(policy_details.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Handle API response with errors or non-200 status codes
        const errorMessage =
          deleteUser?.data?.message || "Something went wrong.";
        setLoading(false);
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      // Handle network or unexpected errors
      // console.error('Error while creating policy:', error);
      toast.error("Failed to delete premises. Please try again later.", {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const handleRemoveUserInPremiseAPI = async (userData, status) => {
    setLoading(true);
    console.log("RemoveuserData--->", userData);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        user_id: encryptData(userData?.user_id?.toString()),
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
      };

      const deleteUser = await apiRequest(
        `api/user/removeUser`,
        "POST",
        payload,
        headers
      );

      if (deleteUser?.data?.status_code === 200) {
        const policy_details = deleteUser.data;
        setLoading(false);
        setActiveMenu(null);
        fetchAlluser(selectedTopBarPremises?.value);
        toast.success(policy_details.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Handle API response with errors or non-200 status codes
        const errorMessage =
          deleteUser?.data?.message || "Something went wrong.";
        setLoading(false);
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      // Handle network or unexpected errors
      // console.error('Error while creating policy:', error);
      toast.error("Failed to delete premises. Please try again later.", {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const Title = "Users";

  const { toastMessage, clearToast } = useToast();
  const [userList, setUserList] = useState([]);
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );
  const [searchTerm, setSearchTerm] = useState(""); // New state for search term

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value); // Update the search term as user types
  };

  const filteredUser = userList.filter((user) => {
    return user.first_name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  useEffect(() => {
    if (toastMessage) {
      toast.success(toastMessage);
      clearToast(); // Clear the toast message after displaying it
    }
  }, [toastMessage, clearToast]);

  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );

  const fetchAlluser = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `api/user/getstaffdetailsbypremise?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        userResponse?.data?.status_code === 200 &&
        userResponse?.data?.data?.staffdetails
      ) {
        const user_details = userResponse.data?.data?.staffdetails;
        setUserList(user_details);
        localStorage.setItem("UserList", JSON.stringify(user_details));
        localStorage.removeItem("stepUserOneData");
        localStorage.removeItem("stepUserTwoData");
        localStorage.removeItem("stepExistUserOneData");
        localStorage.removeItem("stepExistUserTwoData");
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  useEffect(() => {
    fetchAllPolicies();
    pageLoading(true);
    fetchAlluser(selectedTopBarPremises?.value);
  }, []);

  const handleAddExistingUser = () => {
    if (selectedTopBarPremises === null) {
      toast.info(
        "No premises is available. Please create a premise before proceeding with user creation.",
        {
          position: "top-right",
          autoClose: 4000,
        }
      );
    } else {
      navigate("/user/existing/add");
    }
  };

  const handleAddUser = () => {
    if (selectedTopBarPremises === null) {
      toast.info(
        "No premises is available. Please create a premise before proceeding with user creation.",
        {
          position: "top-right",
          autoClose: 4000,
        }
      );
    } else {
      navigate("/user/create");
    }
  };

  const handleStatistics = (userData) => {
    navigate("/user/statistics", {
      state: { userData: userData }, // Passing premise data here
    });
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleTimingPageByUser = (userData) => {
    console.log("userDetails--->", userData);
    // localStorage.setItem("selectedTopBarPremises", JSON.stringify(selectedPremiseData));
    navigate("/report/timing", { state: { user_id: userData.user_id } });
  };

  const handleEditUser = (userData) => {
    const stepUserOneData = {
      firstName: userData?.first_name,
      lastName: userData?.last_name,
      phoneNo: userData?.user_phone_number,
      photo: "",
      customer_account_users_id: userData?.customer_account_users_id,
      is_customer_account_users:
        userData?.customer_account_users_id !== null ? true : false,
      email: userData?.email,
    };
    localStorage.setItem("stepUserOneData", JSON.stringify(stepUserOneData));
    const stepUserTwoData = {
      accessLevel: userData?.access_level,
      operationalMode: userData?.operational_mode,
      passcode: userData?.passcode,
      user_status_enabled:
        userData?.user_active_status === "true" ? true : false,
      leavePolicyId: userData?.timeoff_policy_id,
      checkin_checkout_user_response_feature:
        userData?.checkin_checkout_user_response_feature === "true"
          ? true
          : false,
      timeoff_feature: userData?.timeoff_feature === "true" ? true : false,
      is_image_capture_enabled:
        userData?.is_image_capture_enabled === "true" ? true : false,
      auto_approve_or_reject:
        userData?.auto_approve_or_reject === "approve" ? true : false,
      staff_bt_enabled: userData?.staff_bt_enabled === "true" ? true : false,
      scheduler_feature: userData?.scheduler_feature === "true" ? true : false,
      enforce_shift_time_checkin:
        userData?.enforce_shift_time_checkin === "true" ? true : false,
      checkin_grace_period_minutes: userData?.checkin_grace_period_minutes,
      force_checkout_after_shift_end_time:
        userData?.force_checkout_after_shift_end_time === "true" ? true : false,
      checkout_grace_period_minutes: userData?.checkout_grace_period_minutes,
      can_edit_shift: userData?.can_edit === "true" ? true : false,
    };
    localStorage.setItem("stepUserTwoData", JSON.stringify(stepUserTwoData));
    navigate("/user/update", {
      state: { user: userData }, // Passing premise data here
    });
    // Add your edit logic here
  };

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      pageLoading(true);
      setEditRowId(null);
      fetchAlluser(selected.value);
      setSelectedPremise(selected);
    } else {
      setUserList([]); // Clear the user list if no premise is selected
    }
  };

  const handleDownload = () => {
    const filePath = `${API_BASE_URL}user_bulk_upload_template.csv`;
    const link = document.createElement("a");
    link.href = filePath;
    link.setAttribute("download", "user_bulk_upload_template.csv"); // Set download filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState(""); // Store the uploaded file name
  const [uploading, setUploading] = useState(false); // Upload state

  const userId = "12345"; // Example user_id (You can replace it with dynamic data)

  const handleButtonClick = () => {
    fileInputRef.current.value = ""; // Reset file input before clicking
    fileInputRef.current.click();
  };

  const handleFileUpload = async (event) => {
    if (selectedTopBarPremises === null) {
      toast.info(
        "No premises is available. Please create a premise before proceeding with the bulk user upload.",
        {
          position: "top-right",
          autoClose: 4000,
        }
      );
      return;
    }

    const file = event.target.files[0];

    if (!file) {
      toast.error("Please select a file.");
      return;
    }

    if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      toast.error("Only CSV files are allowed.");
      resetFileInput();
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      const rows = text
        .trim()
        .split("\n")
        .map((row) => row.split(",").map((cell) => cell.trim()))
        .filter((row) => row.some((cell) => cell));

      if (rows.length <= 1) {
        toast.error(
          "The CSV file must contain at least one valid user detail."
        );
        resetFileInput();
        return;
      }

      const headers = rows[0];
      const dataRows = rows.slice(1);

      if (dataRows.length > 100) {
        toast.error("CSV file should contain only 100 data rows.");
        resetFileInput();
        return;
      }

      // for (let i = 0; i < dataRows.length; i++) {
      //   if (dataRows[i].length !== headers.length || dataRows[i].some((cell) => !cell)) {
      //     toast.error(`Error in row ${i + 2}: All fields are required.`);
      //     resetFileInput();
      //     return;
      //   }
      // }

      // Call the API with FormData
      await uploadFile(file);
    };

    reader.readAsText(file);
  };

  const uploadFile = async (file) => {
    setShowUploadModal(true);

    const formData = new FormData();
    formData.append(
      "premise_id",
      encryptData(
        JSON.parse(
          localStorage.getItem("selectedTopBarPremises")
        )?.premise_id?.toString()
      )
    );
    formData.append("csv_file", file);
    formData.append(
      "country_code",
      JSON.parse(localStorage.getItem("selectedTopBarPremises"))?.country_code
    );
    formData.append(
      "time_zone",
      encryptData(
        JSON.parse(localStorage.getItem("selectedTopBarPremises"))?.time_zone
      )
    );
    formData.append("operational_mode", encryptData("manual-sensor"));
    try {
      const response = await axios.post(
        `${API_BASE_URL}web_api/admin/bulkUserUpload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
          responseType: "arraybuffer", // Important for binary responses
          timeout: 300000,
        }
      );
      const contentLength = response.headers.get("content-length");

      const textResponse = new TextDecoder().decode(
        new Uint8Array(response.data)
      );

      if (contentLength === undefined) {
        const jsonResponse = JSON.parse(textResponse);
        toast.error(jsonResponse?.message || "Error uploading file.");
      } else {
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const currentDate = new Date().toLocaleDateString("en-CA");
        link.download = `registration_response_${currentDate}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success(
          `Upload process completed. Please check and verify the downloaded CSV.`,
          {
            position: "top-right",
            autoClose: 4000,
          }
        );
        fetchAlluser(selectedTopBarPremises?.value);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error uploading file.");
    } finally {
      setShowUploadModal(false);
      resetFileInput();
    }
  };

  const resetFileInput = () => {
    fileInputRef.current.value = "";
  };

  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));

  const [view, setView] = useState("card"); // "card" or "table"
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset page
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // Calculate slice for pagination
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedUsers = filteredUser.slice(startIndex, endIndex);

  const totalPages = Math.ceil(filteredUser.length / rowsPerPage);

  const [uploadImage, setUploadImage] = useState(false);
  const [editedUser, setEditedUser] = useState({});

  const [editRowId, setEditRowId] = useState(null); // holds only one row id

  console.log("editedUser--->", editedUser);
  const handleEditClick = (user, index) => {
    // Pick either index OR user.id (if you have a unique field from DB)
    setEditRowId(index);
    setEditedUser({ ...user });
  };

  const handleCancelEdit = () => {
    setEditRowId(null);
    setEditedUser({});
  };

  const handleSaveEdit = () => {
    // 🔹 Call API to update user here
    console.log("Saving user:", editedUser);

    setEditRowId(null);
  };

  const handleFieldChange = (field, value) => {
    setEditedUser((prev) => ({ ...prev, [field]: value }));
  };

  const [errors, setErrors] = React.useState({});

  const rowSchema = Yup.object().shape({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    email: Yup.string().when("is_customer_account_users", {
      is: true, // only validate when Super User is enabled
      then: (schema) =>
        schema.email("Invalid email format").required("Email is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    passcode: Yup.string()
      .matches(/^\d{4}$/, "Passcode must be exactly 4 digits")
      .nullable(),
  });

  const handleSave = async () => {
    try {
      await rowSchema.validate(editedUser, { abortEarly: false });

      // ✅ if validation passes → clear errors
      setErrors({});

      // 🔹 Call API with editedUser
      console.log("Saving user:", editedUser);
      try {
        const customerDetails = JSON.parse(
          localStorage.getItem("customerDetails")
        );
        setLoading(true);

        const selectedTopBarPremises = JSON.parse(
          localStorage.getItem("selectedTopBarPremises")
        );
        console.log("selectedTopBarPremises--->", selectedTopBarPremises);
        const authToken = localStorage.getItem("authToken");
        const headers = {
          Authorization: `Bearer ${authToken}`,
        };

        const generatePassword = (length = 8) => {
          const letters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
          const numbers = "0123456789";
          const allChars = letters + numbers;

          let password = "";

          // Ensure at least one letter and one number
          password += letters[Math.floor(Math.random() * letters.length)];
          password += numbers[Math.floor(Math.random() * numbers.length)];

          // Fill the remaining characters randomly
          for (let i = 2; i < length; i++) {
            password += allChars[Math.floor(Math.random() * allChars.length)];
          }

          // Shuffle the password to avoid fixed positions
          return password
            .split("")
            .sort(() => 0.5 - Math.random())
            .join("");
        };

        const randomPassword = generatePassword(10);

        const payload = {
          customer_account_id: customerDetails?.customerAccountId?.toString(),
          first_name: encryptData(editedUser?.first_name),
          last_name: encryptData(editedUser?.last_name),
          phone_number: encryptData(editedUser?.user_phone_number),
          email: encryptData(editedUser?.email),
          password: encryptData(randomPassword),
          inviteLink: "https://webgamma.businesstime.app/",
          access_level: encryptData(editedUser?.access_level),
          operational_mode: encryptData(editedUser?.operational_mode),
          premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
          status: encryptData(editedUser?.user_active_status?.toString()),
          staff_bt_enabled: encryptData(
            editedUser?.staff_bt_enabled?.toString()
          ),
          timeoff_feature: encryptData(editedUser?.timeoff_feature?.toString()),
          auto_approve_or_reject: encryptData(
            editedUser?.auto_approve_or_reject?.toString()
          ),
          checkin_checkout_user_response_feature: encryptData(
            editedUser?.checkin_checkout_user_response_feature?.toString()
          ),
          is_image_capture_enabled: encryptData(
            editedUser?.is_image_capture_enabled?.toString()
          ),
          is_customer_account_users: encryptData(
            editedUser?.is_customer_account_users?.toString()
          ),
          customer_account_users_id: editedUser?.customer_account_users_id,
          photo: uploadImage ? editedUser?.photo : "",
          device_type: encryptData("web"),
          type: "",
          leave_policy: encryptData(editedUser?.timeoff_policy_id?.toString()),
          scheduler_feature: encryptData(
            editedUser?.scheduler_feature?.toString()
          ),
          enforce_shift_time_checkin: encryptData(
            editedUser?.enforce_shift_time_checkin?.toString()
          ),
          checkin_grace_period_minutes: encryptData(
            editedUser?.checkin_grace_period_minutes?.toString()
          ),
          force_checkout_after_shift_end_time: encryptData(
            editedUser?.force_checkout_after_shift_end_time?.toString()
          ),
          checkout_grace_period_minutes: encryptData(
            editedUser?.checkout_grace_period_minutes?.toString()
          ),
          can_edit_shift: encryptData(editedUser?.can_edit_shift?.toString()),
          ...(editedUser?.first_name && {
            passcode: encryptData(editedUser.passcode),
          }),
        };
        try {
          const response = await apiRequest(
            `web_api/admin/updateUser/${encryptData(
              editedUser?.user_id?.toString()
            )}`,
            "POST",
            payload,
            headers
          );
          if (response.data?.status_code == 200) {
            fetchAlluser(selectedTopBarPremises?.value);
            setLoading(false);
            setTimeout(() => {
              toast.success("User updated successfully");
              // setSubmitting(false);
            }, 100);
          } else {
            setLoading(false);
            toast.error(response.data?.all || "An unexpected error occurred.");
          }
        } catch (error) {
          setLoading(false);
          toast.error(
            error.response?.data?.message || "Login failed. Please try again."
          ); // Handle specific error messages from API
        } finally {
          setLoading(false);
        }
      } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
        // Show error message to the user
      }

      setEditRowId(null);
    } catch (err) {
      if (err.inner) {
        const newErrors = {};
        err.inner.forEach((e) => {
          newErrors[e.path] = e.message;
        });
        setErrors(newErrors);
      }
    }
  };

  const [passcodeError, setPasscodeError] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const inputRef = useRef();

  const handleToggleVisibility = () => {
    setShowOtp((prev) => !prev);
    inputRef.current?.focus();
  };

  const passcodeErrorRef = useRef(null);

  const [sortConfig, setSortConfig] = React.useState({
    key: null,
    direction: "asc",
  });

  const sortedUsers = React.useMemo(() => {
    let sortableUsers = [...paginatedUsers]; // users = your list
    if (sortConfig.key) {
      sortableUsers.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        // Handle strings case-insensitively
        if (typeof aVal === "string") aVal = aVal.toLowerCase();
        if (typeof bVal === "string") bVal = bVal.toLowerCase();

        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableUsers;
  }, [paginatedUsers, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key && prev.direction === "asc") {
        return { key, direction: "desc" };
      }
      return { key, direction: "asc" };
    });
  };

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        <div className="content">
          <div className="contentHeader d-flex align-items-center justify-content-between pb-3">
            <div className="contentDiv">
              {/* <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>{Title}</Breadcrumb.Item>
              </Breadcrumb> */}
              {/* <span className="contentTitle">Report</span> */}
              {/* <span className='contentTitle'>{Title}</span> */}
            </div>
            {/* Search bar on the same row */}
            <div className="search-bar">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange} // Handle input change
              />
            </div>
          </div>
          <div className="premiseDetails">
            <div className="row premisesListDiv">
              <div className="col-lg-12 policyAddRow PremiseCreateBtn userActionBtns">
                <button
                  className="btn policyAddBtn userAddBtn downloadCSV"
                  onClick={handleDownload}
                >
                  <i
                    className="fa fa-download downloadIcon"
                    aria-hidden="true"
                  ></i>
                  Download Bulk-Upload Template
                </button>
                {/* Hidden File Input */}
                <input
                  type="file"
                  accept=".csv"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />

                {/* Custom Upload Button */}
                <button
                  className="btn policyAddBtn userAddBtn downloadCSV"
                  onClick={handleButtonClick}
                >
                  <i
                    className="fa fa-cloud-upload downloadIcon"
                    aria-hidden="true"
                  ></i>
                  Bulk Upload
                </button>
                <button
                  className="btn policyAddBtn userAddBtn downloadCSV"
                  onClick={handleAddExistingUser}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> Add Existing
                  User
                </button>
                <button
                  className="btn policyAddBtn userAddBtn downloadCSV"
                  onClick={handleAddUser}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> New User
                </button>

                <div className="d-flex justify-content-end cardOrTableViewUser">
                  <div
                    className="btn-group shadow-sm"
                    role="group"
                    aria-label="View Toggle"
                  >
                    <button
                      type="button"
                      className={`btn ${
                        view === "card" ? "btn-primary" : "btn-light border"
                      }`}
                      onClick={() => setView("card")}
                      style={{
                        fontWeight: 500,
                        borderRadius: "20px 0 0 20px",
                        padding: "6px 16px",
                      }}
                    >
                      <i className="fas fa-th-large me-2"></i>
                      Card
                    </button>

                    <button
                      type="button"
                      className={`btn ${
                        view === "table" ? "btn-primary" : "btn-light border"
                      }`}
                      onClick={() => setView("table")}
                      style={{
                        fontWeight: 500,
                        borderRadius: "0 20px 20px 0",
                        padding: "6px 16px",
                      }}
                    >
                      <i className="fas fa-table me-2"></i>
                      Table
                    </button>
                  </div>
                </div>
              </div>
              {view === "card" && (
                <div className="row mt-0 g-4">
                  {loading ? (
                    Array(18)
                      .fill(0)
                      .map((_, index) => (
                        <div
                          className="col-6 col-md-4 col-lg-3 col-xxl-3"
                          key={index}
                          style={{
                            padding: "10px", // Optional: add some padding to match layout
                          }}
                        >
                          <div
                            className="card setting-card position-relative"
                            style={{
                              borderRadius: "10px",
                              padding: "0px 0px",
                              backgroundColor: "#ffffff",
                              fontFamily: "'Poppins', sans-serif",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                              border: "none",
                              height: "226px",
                            }}
                          >
                            {/* Shimmer effect in the card */}
                            <Shimmer width="100%" height={226} />
                            {/* Additional shimmer effects for other parts */}
                          </div>
                        </div>
                      ))
                  ) : filteredUser.length > 0 ? (
                    filteredUser.map((userData, index) => (
                      <div
                        className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                        key={index}
                      >
                        <div className="card setting-card position-relative">
                          <div className="user-status-indicator position-absolute top-0 start-0 m-2">
                            {userData?.user_status === "in" && (
                              <img
                                src={InStatusImage} // Replace with actual green gif path
                                alt="In"
                                className="status-icon"
                              />
                            )}
                            {userData?.user_status === "out" && (
                              <div className="status-out" title="Out"></div>
                            )}
                            {userData?.user_status === "inout" && (
                              <div className="status-inout" title="Break"></div>
                            )}
                            {userData?.user_status === "paid_break" && (
                              <div
                                className="status-paid_break"
                                title="Break"
                              ></div>
                            )}
                            {userData?.user_status === "unpaid_break" && (
                              <div
                                className="status-unpaid_break"
                                title="Break"
                              ></div>
                            )}
                            {userData?.user_status === "offline" && (
                              <div
                                className="status-offline"
                                title="Break"
                              ></div>
                            )}
                          </div>

                          <div
                            className={`card-image-div card-mainDiv ${
                              userData?.user_active_status !== "true"
                                ? "inActiveUser"
                                : ""
                            } 
                          ${
                            userData?.user_account_status !== "true"
                              ? "deactivateUser"
                              : ""
                          }`}
                          >
                            <div className="card-image-round-div">
                              <img
                                src={
                                  userData?.photo
                                    ? userData?.photo
                                    : "https://businesstime.app/business-i_backend_uat/public/uploads/dummyuser.png"
                                }
                                className="cardImageTop rounded-circle mx-auto img-fluid"
                                alt="userImage"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleTimingPageByUser(userData);
                                }}
                              />
                            </div>
                            <div className="card-image-option-div">
                              {/* <button
                              className="btn"
                              style={{
                                borderRadius: "20px",
                                backgroundColor: "#2159b1c9",
                                color: "rgb(255 255 255)",
                                fontWeight: "600",
                                padding: "0px 10px",
                                fontSize: "12px",
                                marginTop: "5px",
                                // margin: "0px 12px",
                              }}
                            >
                              Profile
                            </button> */}
                              <button
                                className="btn viewStatistics"
                                style={{
                                  borderRadius: "20px",
                                  backgroundColor: "rgb(47 177 33 / 71%)",
                                  color: "rgb(255 255 255)",
                                  fontWeight: "600",
                                  padding: "0px 10px",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                                onClick={() => handleStatistics(userData)}
                              >
                                Statistics
                              </button>
                            </div>
                          </div>

                          <div
                            className={`card-body ${
                              userData?.user_active_status !== "true"
                                ? "inActiveUser"
                                : ""
                            } 
                          ${
                            userData?.user_account_status !== "true"
                              ? "deactivateUser"
                              : ""
                          }`}
                          >
                            <h5
                              className="card-title"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleTimingPageByUser(userData);
                              }}
                            >
                              {userData?.first_name && userData?.last_name
                                ? `${userData?.first_name} ${userData?.last_name}`
                                    .length > 16
                                  ? `${userData?.first_name.slice(
                                      0,
                                      10
                                    )} ${userData?.last_name.slice(0, 0)}...`
                                  : `${userData?.first_name} ${userData?.last_name}`
                                : ""}
                            </h5>
                            <p
                              className="card-text"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleTimingPageByUser(userData);
                              }}
                            >
                              {userData?.customer_account_users_id
                                ? "Super User"
                                : capitalizeFirstLetter(userData?.access_level)}
                            </p>
                          </div>
                          {/* Three-dot menu */}
                          {(userData?.did_user_create_account !== "true" ||
                            (userData?.did_user_create_account === "true" &&
                              userData?.user_id ===
                                customerDetails?.userId)) && (
                            <div
                              className="menu-container position-absolute"
                              style={{ top: "10px", right: "10px" }}
                            >
                              <i
                                className="fa fa-ellipsis-v"
                                aria-hidden="true"
                                onClick={() => toggleMenu(userData.user_id)}
                                style={{
                                  cursor: "pointer",
                                  paddingLeft: "10px",
                                  paddingRight: "1px",
                                  fontSize: "15px",
                                  color: "#b0b4c0",
                                }}
                              ></i>
                              {activeMenu === userData.user_id && (
                                <div className="premiseActionDropDownMenu show shadow">
                                  {userData?.user_account_status === "true" && (
                                    <button
                                      className="btn premiseActionItem userActionItem"
                                      onClick={() => {
                                        if (
                                          userData?.user_account_status ===
                                          "true"
                                        ) {
                                          handleEditUser(userData);
                                        }
                                      }}
                                    >
                                      Edit
                                    </button>
                                  )}
                                  {userData?.user_account_status === "true" &&
                                  userData?.user_id !==
                                    customerDetails?.userId ? (
                                    <>
                                      <button
                                        className="btn premiseActionItem userActionItem text-danger"
                                        onClick={() =>
                                          handleRemoveUser(
                                            userData,
                                            "false",
                                            "delete"
                                          )
                                        }
                                      >
                                        Delete
                                      </button>
                                      {userData?.user_active_status !==
                                        "true" &&
                                      userData?.user_id !==
                                        customerDetails?.userId ? (
                                        <button
                                          className="btn premiseActionItem userActionItem text-success"
                                          onClick={() =>
                                            handleUserStatus(
                                              userData,
                                              "true",
                                              "activate"
                                            )
                                          }
                                        >
                                          Activate
                                        </button>
                                      ) : (
                                        userData?.user_id !==
                                          customerDetails?.userId && (
                                          <button
                                            className="btn premiseActionItem userActionItem text-danger"
                                            onClick={() =>
                                              handleUserStatus(
                                                userData,
                                                "false",
                                                "deactivate"
                                              )
                                            }
                                          >
                                            In-Activate
                                          </button>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    userData?.user_id !==
                                      customerDetails?.userId && (
                                      <button
                                        className="btn premiseActionItem userActionItem text-success"
                                        onClick={() =>
                                          handleRemoveUser(
                                            userData,
                                            "true",
                                            "restore"
                                          )
                                        }
                                      >
                                        Restore
                                      </button>
                                    )
                                  )}
                                  <button
                                    className="btn premiseActionItem userActionItem text-danger"
                                    onClick={() =>
                                      handleRemoveUserData(
                                        userData,
                                        "false",
                                        "remove"
                                      )
                                    }
                                  >
                                    Remove User
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      className="noPolicyDiv d-flex flex-column align-items-center justify-content-start vh-100 bg-custom"
                      style={{
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        color: "#fff",
                        textAlign: "center",
                      }}
                    >
                      <h1
                        style={{
                          fontSize: "1.2rem",
                          fontWeight: "bold",
                          color: "#2d64bc",
                        }}
                      >
                        No User Found
                      </h1>
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginTop: "10px",
                          maxWidth: "600px",
                          color: "#6c6c6c",
                        }}
                      >
                        Currently, there are no users available. Create a new
                        user to get started.
                      </p>
                      {/* <button
                      className="btn policyAddBtn"
                      style={{ padding: "4px 10px", fontSize: "0.8rem" }}
                      onClick={handleAddPremise}
                    >
                      <i className="fa fa-plus p-1" aria-hidden="true"></i>
                      Create Premises
                    </button> */}
                    </div>
                  )}
                </div>
              )}

              {/* Table View */}
              {view === "table" && (
                  <div className="row mt-0 g-4">
                <Paper
                className="userTableView"
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    padding: 2,
                    marginTop: 3,
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {/* Rows per page selector (TOP) */}
                  <div className="d-flex justify-content-start">
                    <span
                      style={{
                        marginRight: "10px",
                        marginTop: "6px",
                        fontWeight: 500,
                        fontSize: "0.9rem",
                        color: "#444",
                      }}
                    >
                      Rows per page:
                    </span>
                    <Select
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      size="small"
                      sx={{
                        minWidth: "70px",
                        fontSize: "0.9rem",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "8px",
                        },
                      }}
                    >
                      {[5, 10, 25, 50].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  {/* Table */}
                  <TableContainer sx={{ maxHeight: 500, overflowX: "auto", maxWidth:" clamp(600px, 78vw, 2000px);" }}>
                    <Table stickyHeader sx={{ minWidth: 100 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "600" }}>
                            Photo
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("first_name")}
                            sx={{ minWidth: "160px", fontWeight: "600" }}
                          >
                            First Name{" "}
                            {sortConfig.key === "first_name"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "⇅"}
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("last_name")}
                            sx={{ minWidth: "160px", fontWeight: "600" }}
                          >
                            Last Name{" "}
                            {sortConfig.key === "last_name"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "⇅"}
                          </TableCell>
                          <TableCell
                            sx={{ minWidth: "150px", fontWeight: "600" }}
                          >
                            Mobile No
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "600", minWidth: "150px" }}
                          >
                            Super User
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("email")}
                            sx={{ minWidth: "150px", fontWeight: "600" }}
                          >
                            Email{" "}
                            {sortConfig.key === "email"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "⇅"}
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("access_level")}
                            sx={{ minWidth: "150px", fontWeight: "600" }}
                          >
                            Access Level{" "}
                            {sortConfig.key === "access_level"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "⇅"}
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("operational_mode")}
                            sx={{ minWidth: "200px", fontWeight: "600" }}
                          >
                            Operational Mode{" "}
                            {sortConfig.key === "operational_mode"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "⇅"}
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "600", minWidth: "150px" }}
                          >
                            Passcode
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("timeoff_feature")}
                            sx={{ fontWeight: "600", minWidth: "180px" }}
                          >
                            Leave & Time-Off{" "}
                            {sortConfig.key === "timeoff_feature"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "⇅"}
                          </TableCell>
                          <TableCell
                            sx={{ minWidth: "200px", fontWeight: "600" }}
                          >
                            Leave Policy
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("scheduler_feature")}
                            sx={{ minWidth: "200px", fontWeight: "600" }}
                          >
                            Shift Scheduling Setting{" "}
                            {sortConfig.key === "scheduler_feature"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "⇅"}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleSort("is_image_capture_enabled")
                            }
                            sx={{
                              maxWidth: 200, // set your preferred width
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                          >
                            <Tooltip
                              placement="left"
                              title="Capture image during Check-In/Check-Out"
                              arrow
                            >
                              <span>
                                Capture image during Check-In/Check-Out{" "}
                                {sortConfig.key === "is_image_capture_enabled"
                                  ? sortConfig.direction === "asc"
                                    ? "↑"
                                    : "↓"
                                  : "⇅"}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("auto_approve_or_reject")}
                            sx={{
                              maxWidth: 200, // set your preferred width
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                          >
                            <Tooltip
                              placement="left"
                              title="After 24hrs of 'Report Time' request,
                                automatically Approve/Reject the request?"
                              arrow
                            >
                              <span>
                                After 24hrs of 'Report Time' request,
                                automatically Approve/Reject the request?
                                {sortConfig.key === "auto_approve_or_reject"
                                  ? sortConfig.direction === "asc"
                                    ? "↑"
                                    : "↓"
                                  : "⇅"}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleSort(
                                "checkin_checkout_user_response_feature"
                              )
                            }
                            sx={{
                              maxWidth: 200, // set your preferred width
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                          >
                            <Tooltip
                              placement="left"
                              title=" Let users accept or override the recorded
                                Check-In / Check-Out time"
                              arrow
                            >
                              <span>
                                Let users accept or override the recorded
                                Check-In / Check-Out time{" "}
                                {sortConfig.key ===
                                "checkin_checkout_user_response_feature"
                                  ? sortConfig.direction === "asc"
                                    ? "↑"
                                    : "↓"
                                  : "⇅"}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            onClick={() => handleSort("user_active_status")}
                            sx={{
                              maxWidth: 200, // set your preferred width
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                          >
                            <Tooltip
                              placement="left"
                              title="User Status - If disabled, the user will not
                                have access to the system"
                              arrow
                            >
                              <span>
                                User Status - If disabled, the user will not
                                have access to the system{" "}
                                {sortConfig.key === "user_active_status"
                                  ? sortConfig.direction === "asc"
                                    ? "↑"
                                    : "↓"
                                  : "⇅"}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                             onClick={() => handleSort("staff_bt_enabled")}
                            sx={{
                              maxWidth: 200, // set your preferred width
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                          >
                            <Tooltip
                              placement="left"
                              title="Sensor Access - If disabled, the user will not
                                have permission to connect to the sensors"
                              arrow
                            >
                              <span>
                                Sensor Access - If disabled, the user will not
                                have permission to connect to the sensors
                                                  {sortConfig.key === "staff_bt_enabled"
                                  ? sortConfig.direction === "asc"
                                    ? "↑"
                                    : "↓"
                                  : "⇅"}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              position: "sticky",
                              right: 0,
                              background: "#f8f9fa", // light background so it stands out
                              zIndex: 2,
                              fontWeight: "600",
                            }}
                          >
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {sortedUsers.map((user, index) => {
                          const isEditing = editRowId === index;

                          return (
                            <TableRow hover key={index}>
                              {/* Profile Pic with Upload */}
                              <TableCell
                                sx={{
                                  padding: "0px 10px",
                                  textAlign: "center",
                                }}
                              >
                                <div className="position-relative d-inline-block">
                                  <Avatar
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                    src={
                                      isEditing
                                        ? editedUser.photo ||
                                          "https://businesstime.app/business-i_backend_uat/public/uploads/dummyuser.png"
                                        : user.photo ||
                                          "https://businesstime.app/business-i_backend_uat/public/uploads/dummyuser.png"
                                    }
                                    alt="profile"
                                    sx={{ width: 50, height: 50 }}
                                  />

                                  {isEditing && (
                                    <>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        id={`upload-${index}`}
                                        style={{ display: "none" }}
                                        onChange={(e) => {
                                          const file = e.target.files[0];
                                          if (file) {
                                            setUploadImage(true);
                                            const reader = new FileReader();
                                            reader.onload = () => {
                                              setEditedUser({
                                                ...editedUser,
                                                photo: reader.result,
                                              });
                                            };
                                            reader.readAsDataURL(file);
                                          }
                                        }}
                                      />
                                      <label
                                        htmlFor={`upload-${index}`}
                                        className="position-absolute d-flex justify-content-center align-items-center"
                                        style={{
                                          bottom: 0,
                                          right: 0,
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "50%",
                                          background: "#2d64bc",
                                          cursor: "pointer",
                                          boxShadow:
                                            "0 2px 6px rgba(0,0,0,0.3)",
                                        }}
                                      >
                                        <i
                                          className="fas fa-camera"
                                          style={{
                                            color: "#fff",
                                            fontSize: "14px",
                                          }}
                                        ></i>
                                      </label>
                                    </>
                                  )}
                                </div>
                              </TableCell>

                              {/* First Name */}
                              <TableCell>
                                {isEditing ? (
                                  <div>
                                    <input
                                      type="text"
                                      value={editedUser.first_name || ""}
                                      onChange={(e) => {
                                        setEditedUser({
                                          ...editedUser,
                                          first_name: e.target.value,
                                        });
                                        if (errors.first_name) {
                                          setErrors({
                                            ...errors,
                                            first_name: "",
                                          }); // ✅ clear only this error
                                        }
                                      }}
                                      className="form-control form-control-sm"
                                      placeholder="First Name"
                                    />
                                    {errors.first_name && (
                                      <div className="text-danger small">
                                        {errors.first_name}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <span
                                    style={{
                                      fontWeight: 500,
                                      color: "#2d64bc",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {user.first_name}
                                  </span>
                                )}
                              </TableCell>

                              {/* Last Name */}
                              <TableCell>
                                {isEditing ? (
                                  <div>
                                    <input
                                      type="text"
                                      value={editedUser.last_name || ""}
                                      onChange={(e) => {
                                        setEditedUser({
                                          ...editedUser,
                                          last_name: e.target.value,
                                        });
                                        if (errors.last_name) {
                                          setErrors({
                                            ...errors,
                                            last_name: "",
                                          }); // ✅ clear only this error
                                        }
                                      }}
                                      className="form-control form-control-sm"
                                      placeholder="Last Name"
                                    />
                                    {errors.last_name && (
                                      <div className="text-danger small">
                                        {errors.last_name}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <span
                                    style={{
                                      fontWeight: 500,
                                      color: "#2d64bc",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {user.last_name}
                                  </span>
                                )}
                              </TableCell>

                              {/* Last Name */}
                              <TableCell>
                                {isEditing ? (
                                  <input
                                    type="text"
                                    value={editedUser.user_phone_number}
                                    // onChange={(e) =>
                                    //   setEditedUser({
                                    //     ...editedUser,
                                    //     user_phone_number: e.target.value,
                                    //   })
                                    // }
                                    readOnly={true}
                                    className="form-control form-control-sm viewOptionField"
                                    placeholder="Mobile No"
                                  />
                                ) : (
                                  <span
                                    style={{
                                      fontWeight: 500,
                                      color: "#2d64bc",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {user.user_phone_number}
                                  </span>
                                )}
                              </TableCell>
                              {/* 🔹 Super User Toggle */}
                              <TableCell>
                                {isEditing ? (
                                  <div
                                    className={`d-flex align-items-center justify-content-between ${
                                      user?.user_id === customerDetails?.userId
                                        ? "cursor-not-allowed"
                                        : ""
                                    }`}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.is_customer_account_users
                                          ) === "true"
                                            ? "#aaa"
                                            : "#f44336",
                                      }}
                                    >
                                      No
                                    </span>

                                    <Switch
                                      className={`superUserSwitch ${
                                        user?.user_id == customerDetails?.userId
                                          ? "cursor-not-allowed"
                                          : ""
                                      }`}
                                      onColor="#4caf50"
                                      offColor="#f44336"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={21}
                                      width={40}
                                      handleDiameter={20}
                                      checked={
                                        String(
                                          editedUser.is_customer_account_users
                                        ) === "true"
                                      }
                                      onChange={(checked) => {
                                        if (
                                          user?.user_id !==
                                          customerDetails?.userId
                                        ) {
                                          setEditedUser({
                                            ...editedUser,
                                            is_customer_account_users: checked,
                                          });
                                        }
                                      }}
                                    />

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.is_customer_account_users
                                          ) === "true"
                                            ? "#4caf50"
                                            : "#aaa",
                                      }}
                                    >
                                      Yes
                                    </span>
                                  </div>
                                ) : (
                                  <span
                                    style={{
                                      fontWeight: "500",
                                      cursor: "pointer",
                                      color:
                                        user?.customer_account_users_id !== null
                                          ? "green"
                                          : "red",
                                    }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {user?.customer_account_users_id !== null
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                )}
                              </TableCell>

                              {/* 🔹 Conditional Email Field (only when Super User is ON) */}
                              {/* Email → required only if Super User enabled */}
                              <TableCell>
                                {isEditing &&
                                editedUser.is_customer_account_users ? (
                                  <div>
                                    <input
                                      type="text"
                                      value={editedUser.email || ""}
                                      readOnly={user?.email}
                                      onChange={(e) => {
                                        setEditedUser({
                                          ...editedUser,
                                          email: e.target.value,
                                        });

                                        // ✅ clear error while typing
                                        if (errors.email) {
                                          setErrors({ ...errors, email: "" });
                                        }
                                      }}
                                      className={`form-control form-control-sm ${
                                        user?.email ? "viewOptionField" : ""
                                      }`}
                                      placeholder="Email"
                                    />
                                    {errors.email && (
                                      <div className="text-danger small">
                                        {errors.email}
                                      </div>
                                    )}
                                  </div>
                                ) : user?.customer_account_users_id !== null ? (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {user.email}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </TableCell>

                              {/* Role */}
                              <TableCell>
                                {isEditing ? (
                                  editedUser?.is_customer_account_users ? (
                                    <select
                                      value={editedUser.access_level}
                                      className="form-select form-select-sm"
                                    >
                                      <option value="admin">Admin</option>
                                    </select>
                                  ) : (
                                    <select
                                      value={editedUser.access_level}
                                      onChange={(e) =>
                                        setEditedUser({
                                          ...editedUser,
                                          access_level: e.target.value,
                                        })
                                      }
                                      className="form-select form-select-sm"
                                    >
                                      <option value="admin">Admin</option>
                                      <option value="manager">Manager</option>
                                      <option value="staff">Staff</option>
                                    </select>
                                  )
                                ) : user.customer_account_users_id ? (
                                  "Super User"
                                ) : (
                                  user.access_level
                                )}
                              </TableCell>

                              <TableCell>
                                {editRowId === index ? (
                                  <select
                                    value={editedUser.operational_mode || ""}
                                    onChange={(e) =>
                                      handleFieldChange(
                                        "operational_mode",
                                        e.target.value
                                      )
                                    }
                                    className="form-select form-select-sm"
                                    style={{ width: "150px" }}
                                  >
                                    <option value="manual-sensor">
                                      Manual mode
                                    </option>
                                    {selectedTopBarPremises?.autopilot_feature ===
                                      "true" && (
                                      <option value="auto">Auto</option>
                                    )}
                                    {selectedTopBarPremises?.work_location_feature ===
                                      "true" && (
                                      <option value="field-geofence">
                                        Field geofence
                                      </option>
                                    )}
                                  </select>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {user.operational_mode || "-"}
                                  </span>
                                )}
                              </TableCell>

                              {/* 🔹 Passcode Cell */}
                              <TableCell>
                                {selectedTopBarPremises?.kiosk_passcode_enabled ==
                                "true" ? (
                                  editRowId === index ? (
                                    <div
                                      ref={passcodeErrorRef}
                                      style={{
                                        position: "relative",
                                        width: "200px",
                                        marginLeft: "auto",
                                      }}
                                    >
                                      <div style={{ width: "120px" }}>
                                        <input
                                          value={
                                            showOtp
                                              ? editedUser.passcode
                                              : "•".repeat(
                                                  editedUser.passcode.length
                                                )
                                          }
                                          maxLength={4}
                                          inputMode="numeric"
                                          className={`form-control form-control-sm ${
                                            errors.passcode ? "is-invalid" : ""
                                          }`}
                                          placeholder="Passcode"
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(/\D/g, ""); // allow only digits
                                            setEditedUser({
                                              ...editedUser,
                                              passcode: value,
                                            });
                                            setErrors((prev) => ({
                                              ...prev,
                                              passcode: "",
                                            })); // clear error while typing
                                          }}
                                        />

                                        {/* Show/Hide Icon */}
                                        <img
                                          className="togglePasscode"
                                          src={
                                            showOtp
                                              ? showPasswordIcon
                                              : hidePasswordIcon
                                          }
                                          alt="Toggle visibility"
                                          onClick={handleToggleVisibility}
                                          style={{
                                            position: "absolute",
                                            top: passcodeError ? "34%" : "50%",
                                            right: "85px",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            height: "15px",
                                            width: "15px",
                                            opacity: 0.8,
                                          }}
                                        />
                                        {errors.passcode && (
                                          <div
                                            className="text-danger"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {errors.passcode}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setEditRowId(index);
                                        setEditedUser({
                                          ...user,
                                          is_customer_account_users:
                                            user?.customer_account_users_id !==
                                            null,
                                        });
                                      }}
                                    >
                                      {user.passcode ? "••••" : "-"}
                                    </span>
                                  )
                                ) : (
                                  "-"
                                )}
                              </TableCell>

                              {/* Example Switch for Time-Off */}
                              <TableCell>
                                {editRowId === index ? (
                                  <div className="d-flex align-items-center">
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(editedUser.timeoff_feature) ===
                                          "true"
                                            ? "#aaa"
                                            : "#f44336",
                                        marginRight: "5px",
                                      }}
                                    >
                                      Disable
                                    </span>

                                    <Switch
                                      onColor="#4caf50"
                                      offColor="#f44336"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={21}
                                      width={40}
                                      handleDiameter={20}
                                      checked={
                                        String(editedUser.timeoff_feature) ===
                                        "true"
                                      }
                                      onChange={(checked) =>
                                        handleFieldChange(
                                          "timeoff_feature",
                                          checked.toString()
                                        )
                                      }
                                    />

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(editedUser.timeoff_feature) ===
                                          "true"
                                            ? "#4caf50"
                                            : "#aaa",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Enable
                                    </span>
                                  </div>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {String(user.timeoff_feature) === "true" ? (
                                      <span className="badge bg-success">
                                        Enabled
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        Disabled
                                      </span>
                                    )}
                                  </span>
                                )}
                              </TableCell>

                              {/* Leave Policy */}
                              <TableCell>
                                {editRowId === index ? (
                                  <select
                                    value={editedUser.timeoff_policy_id || ""}
                                    // onChange={(e) =>
                                    //   handleFieldChange(
                                    //     "leavePolicyId",
                                    //     e.target.value
                                    //   )
                                    // }
                                    disabled={true}
                                    className="form-select form-select-sm viewOptionField"
                                    style={{ width: "180px" }}
                                  >
                                    <option value="">
                                      {policyList.length === 0
                                        ? "No policies"
                                        : "Not assigned"}
                                    </option>
                                    {policyList.map((policy) => (
                                      <option
                                        key={policy.timeoff_policy_id}
                                        value={policy.timeoff_policy_id}
                                      >
                                        {policy.policy_name}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {" "}
                                    {
                                      policyList.find(
                                        (p) =>
                                          p.timeoff_policy_id ===
                                          user.timeoff_policy_id
                                      )?.policy_name || "-" // ✅ resolve name by matching id
                                    }
                                  </span>
                                )}
                              </TableCell>

                              <TableCell style={{ minWidth: "250px" }}>
                                {selectedTopBarPremises?.scheduler_feature ==
                                "true" ? (
                                  editRowId === index ? (
                                    <div>
                                      {/* Enable Shift-based Scheduling */}
                                      <div className="d-flex align-items-center mb-2">
                                        <label
                                          className="me-2"
                                          style={{
                                            fontSize: "12px",
                                            minWidth: "140px",
                                          }}
                                        >
                                          Shift Scheduling
                                        </label>
                                        <Switch
                                          onColor="#4caf50"
                                          offColor="#f44336"
                                          uncheckedIcon={false}
                                          checkedIcon={false}
                                          height={20}
                                          width={38}
                                          handleDiameter={18}
                                          checked={
                                            String(
                                              editedUser.scheduler_feature
                                            ) === "true"
                                          }
                                          onChange={(checked) =>
                                            handleFieldChange(
                                              "scheduler_feature",
                                              checked.toString()
                                            )
                                          }
                                        />
                                      </div>

                                      {String(editedUser.scheduler_feature) ===
                                        "true" && (
                                        <>
                                          {/* Enforce Check-in */}
                                          <div className="d-flex align-items-center mb-2">
                                            <label
                                              className="me-2"
                                              style={{
                                                fontSize: "12px",
                                                minWidth: "140px",
                                              }}
                                            >
                                              Enforce Check-In
                                            </label>
                                            <Switch
                                              onColor="#4caf50"
                                              offColor="#f44336"
                                              uncheckedIcon={false}
                                              checkedIcon={false}
                                              height={20}
                                              width={38}
                                              handleDiameter={18}
                                              checked={
                                                String(
                                                  editedUser.enforce_shift_time_checkin
                                                ) === "true"
                                              }
                                              onChange={(checked) =>
                                                handleFieldChange(
                                                  "enforce_shift_time_checkin",
                                                  checked.toString()
                                                )
                                              }
                                            />
                                          </div>

                                          {/* Grace Period Dropdown */}
                                          <div className="d-flex align-items-center mb-2">
                                            <label
                                              className="me-2"
                                              style={{
                                                fontSize: "12px",
                                                minWidth: "140px",
                                              }}
                                            >
                                              Check-In Grace
                                            </label>
                                            <select
                                              value={
                                                editedUser.checkin_grace_period_minutes ||
                                                ""
                                              }
                                              onChange={(e) =>
                                                handleFieldChange(
                                                  "checkin_grace_period_minutes",
                                                  e.target.value
                                                )
                                              }
                                              className="form-select form-select-sm"
                                              style={{ width: "120px" }}
                                            >
                                              <option value="" disabled>
                                                Select delay time
                                              </option>
                                              {Array.from(
                                                { length: 9 },
                                                (_, i) => (
                                                  <option
                                                    key={i}
                                                    value={(i + 1) * 5}
                                                  >
                                                    {(i + 1) * 5} min
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          </div>

                                          {/* Force Checkout */}
                                          <div className="d-flex align-items-center mb-2">
                                            <label
                                              className="me-2"
                                              style={{
                                                fontSize: "12px",
                                                minWidth: "140px",
                                              }}
                                            >
                                              Force Checkout
                                            </label>
                                            <Switch
                                              onColor="#4caf50"
                                              offColor="#f44336"
                                              uncheckedIcon={false}
                                              checkedIcon={false}
                                              height={20}
                                              width={38}
                                              handleDiameter={18}
                                              checked={
                                                String(
                                                  editedUser.force_checkout_after_shift_end_time
                                                ) === "true"
                                              }
                                              onChange={(checked) =>
                                                handleFieldChange(
                                                  "force_checkout_after_shift_end_time",
                                                  checked.toString()
                                                )
                                              }
                                            />
                                          </div>

                                          {/* Checkout Grace Period */}
                                          <div className="d-flex align-items-center mb-2">
                                            <label
                                              className="me-2"
                                              style={{
                                                fontSize: "12px",
                                                minWidth: "140px",
                                              }}
                                            >
                                              Check-Out Grace
                                            </label>
                                            <select
                                              value={
                                                editedUser.checkout_grace_period_minutes ||
                                                ""
                                              }
                                              onChange={(e) =>
                                                handleFieldChange(
                                                  "checkout_grace_period_minutes",
                                                  e.target.value
                                                )
                                              }
                                              className="form-select form-select-sm"
                                              style={{ width: "120px" }}
                                            >
                                              <option value="" disabled>
                                                Select delay time
                                              </option>
                                              {Array.from(
                                                { length: 9 },
                                                (_, i) => (
                                                  <option
                                                    key={i}
                                                    value={(i + 1) * 5}
                                                  >
                                                    {(i + 1) * 5} min
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          </div>

                                          {/* Can Edit Shift */}
                                          <div className="d-flex align-items-center">
                                            <label
                                              className="me-2"
                                              style={{
                                                fontSize: "12px",
                                                minWidth: "140px",
                                              }}
                                            >
                                              Can Edit Shift
                                            </label>
                                            <Switch
                                              onColor="#4caf50"
                                              offColor="#f44336"
                                              uncheckedIcon={false}
                                              checkedIcon={false}
                                              height={20}
                                              width={38}
                                              handleDiameter={18}
                                              checked={
                                                String(
                                                  editedUser.can_edit_shift
                                                ) === "true"
                                              }
                                              onChange={(checked) =>
                                                handleFieldChange(
                                                  "can_edit_shift",
                                                  checked.toString()
                                                )
                                              }
                                            />
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setEditRowId(index);
                                        setEditedUser({
                                          ...user,
                                          is_customer_account_users:
                                            user?.customer_account_users_id !==
                                            null,
                                        });
                                      }}
                                    >
                                      {String(user.scheduler_feature) ===
                                      "true" ? (
                                        <span className="badge bg-success">
                                          Enabled
                                        </span>
                                      ) : (
                                        <span className="badge bg-danger">
                                          Disabled
                                        </span>
                                      )}
                                    </span>
                                  )
                                ) : (
                                  "-"
                                )}
                              </TableCell>

                              <TableCell>
                                {editRowId === index ? (
                                  <div className="d-flex align-items-center">
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.is_image_capture_enabled
                                          ) === "true"
                                            ? "#aaa"
                                            : "#f44336",
                                        marginRight: "5px",
                                      }}
                                    >
                                      Disable
                                    </span>

                                    <Switch
                                      onColor="#4caf50"
                                      offColor="#f44336"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={20}
                                      width={38}
                                      handleDiameter={18}
                                      checked={
                                        String(
                                          editedUser.is_image_capture_enabled
                                        ) === "true"
                                      }
                                      onChange={(checked) =>
                                        handleFieldChange(
                                          "is_image_capture_enabled",
                                          checked.toString()
                                        )
                                      }
                                    />

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.is_image_capture_enabled
                                          ) === "true"
                                            ? "#4caf50"
                                            : "#aaa",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      Enable
                                    </span>
                                  </div>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {String(user.is_image_capture_enabled) ===
                                    "true" ? (
                                      <span className="badge bg-success">
                                        Enabled
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        Disabled
                                      </span>
                                    )}
                                  </span>
                                )}
                              </TableCell>

                              <TableCell>
                                {editRowId === index ? (
                                  <div className="d-flex align-items-center justify-content-center">
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color: ["approve", "true"].includes(
                                          String(
                                            editedUser.auto_approve_or_reject
                                          )
                                        )
                                          ? "#aaa"
                                          : "#f44336",
                                        marginRight: "10px",
                                      }}
                                    >
                                      Reject
                                    </span>

                                    <Switch
                                      onColor="#4caf50"
                                      offColor="#f44336"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={21}
                                      width={40}
                                      className=""
                                      handleDiameter={20}
                                      id={`auto_approve_or_reject_${index}`}
                                      checked={
                                        String(
                                          editedUser.auto_approve_or_reject
                                        ) === "approve" ||
                                        String(
                                          editedUser.auto_approve_or_reject
                                        ) === "true"
                                      }
                                      onChange={(checked) =>
                                        handleFieldChange(
                                          "auto_approve_or_reject",
                                          checked.toString()
                                        )
                                      }
                                    />

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color: ["approve", "true"].includes(
                                          String(
                                            editedUser.auto_approve_or_reject
                                          )
                                        )
                                          ? "#4caf50"
                                          : "#aaa",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Approve
                                    </span>
                                  </div>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {String(user.auto_approve_or_reject) ===
                                    "approve" ? (
                                      <span className="badge bg-success">
                                        Approve
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        Reject
                                      </span>
                                    )}
                                  </span>
                                )}
                              </TableCell>

                              <TableCell>
                                {editRowId === index ? (
                                  <div className="d-flex align-items-center justify-content-center">
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.checkin_checkout_user_response_feature
                                          ) === "true"
                                            ? "#aaa"
                                            : "#f44336",
                                        marginRight: "10px",
                                      }}
                                    >
                                      Disable
                                    </span>

                                    <Switch
                                      onColor="#4caf50"
                                      offColor="#f44336"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={21}
                                      width={40}
                                      className=""
                                      handleDiameter={20}
                                      id={`checkin_checkout_user_response_feature_${index}`}
                                      checked={
                                        String(
                                          editedUser.checkin_checkout_user_response_feature
                                        ) === "true"
                                      }
                                      onChange={(checked) =>
                                        handleFieldChange(
                                          "checkin_checkout_user_response_feature",
                                          checked.toString()
                                        )
                                      }
                                    />

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.checkin_checkout_user_response_feature
                                          ) === "true"
                                            ? "#4caf50"
                                            : "#aaa",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Enable
                                    </span>
                                  </div>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {String(
                                      user.checkin_checkout_user_response_feature
                                    ) === "true" ? (
                                      <span className="badge bg-success">
                                        Enabled
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        Disabled
                                      </span>
                                    )}
                                  </span>
                                )}
                              </TableCell>

                              <TableCell>
                                {editRowId === index ? (
                                  <div
                                    className={`d-flex align-items-center justify-content-center ${
                                      user?.user_id === customerDetails?.userId
                                        ? "cursor-not-allowed"
                                        : ""
                                    }`}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.user_active_status
                                          ) === "true"
                                            ? "#aaa"
                                            : "#f44336",
                                        marginRight: "10px",
                                      }}
                                    >
                                      Inactive
                                    </span>

                                    <Switch
                                      onColor="#4caf50"
                                      offColor="#f44336"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={21}
                                      width={40}
                                      className={`${
                                        user?.user_id ===
                                        customerDetails?.userId
                                          ? "cursor-not-allowed"
                                          : ""
                                      }`}
                                      handleDiameter={20}
                                      id={`user_active_status${index}`}
                                      checked={
                                        String(
                                          editedUser.user_active_status
                                        ) === "true"
                                      }
                                      onChange={(checked) => {
                                        if (
                                          user?.user_id !==
                                          customerDetails?.userId
                                        ) {
                                          handleFieldChange(
                                            "user_active_status",
                                            checked.toString()
                                          );
                                        }
                                      }}
                                    />

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.user_active_status
                                          ) === "true"
                                            ? "#4caf50"
                                            : "#aaa",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Active
                                    </span>
                                  </div>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {String(user.user_active_status) ===
                                    "true" ? (
                                      <span className="badge bg-success">
                                        Active
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        Inactive
                                      </span>
                                    )}
                                  </span>
                                )}
                              </TableCell>

                              <TableCell>
                                {editRowId === index ? (
                                  <div className="d-flex align-items-center justify-content-center">
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.staff_bt_enabled
                                          ) === "true"
                                            ? "#aaa"
                                            : "#f44336",
                                        marginRight: "10px",
                                      }}
                                    >
                                      Disable
                                    </span>

                                    <Switch
                                      onColor="#4caf50"
                                      offColor="#f44336"
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      height={21}
                                      width={40}
                                      className=""
                                      handleDiameter={20}
                                      id={`staff_bt_enabled_${index}`}
                                      checked={
                                        String(editedUser.staff_bt_enabled) ===
                                        "true"
                                      }
                                      onChange={(checked) => {
                                        handleFieldChange(
                                          "staff_bt_enabled",
                                          checked.toString()
                                        );
                                      }}
                                    />

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          String(
                                            editedUser.staff_bt_enabled
                                          ) === "true"
                                            ? "#4caf50"
                                            : "#aaa",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Enable
                                    </span>
                                  </div>
                                ) : (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    {String(user.staff_bt_enabled) ===
                                    "true" ? (
                                      <span className="badge bg-success">
                                        Enabled
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        Disabled
                                      </span>
                                    )}
                                  </span>
                                )}
                              </TableCell>

                              {/* Actions */}
                              <TableCell
                                align="right"
                                sx={{
                                  position: "sticky",
                                  right: 0,
                                  background: "#fff", // keep clean
                                  zIndex: 1,
                                }}
                              >
                                {isEditing ? (
                                  <div style={{ width: "100px" }}>
                                    <button
                                      style={{ padding: "5px 8px" }}
                                      className="btn btn-sm btn-success me-2"
                                      onClick={handleSave}
                                    >
                                      <i className="fas fa-check"></i>
                                    </button>
                                    <button
                                      style={{ padding: "5px 10px" }}
                                      className="btn btn-sm btn-secondary"
                                      onClick={() => setEditRowId(null)}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </div>
                                ) : (
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => {
                                      setEditRowId(index);
                                      setEditedUser({
                                        ...user,
                                        is_customer_account_users:
                                          user?.customer_account_users_id !==
                                          null,
                                      });
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Numbered Pagination (BOTTOM) */}
                  <div className="d-flex justify-content-center mt-3">
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                      shape="rounded"
                      siblingCount={1}
                      boundaryCount={1}
                      sx={{
                        "& .MuiPaginationItem-root": {
                          fontWeight: "500",
                          fontSize: "0.85rem",
                        },
                      }}
                    />
                  </div>
                </Paper>
                  </div>
              )}
            </div>
            {showModal && (
              <div
                className="modal show d-block"
                tabIndex="-1"
                role="dialog"
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.5)", // Dimmed background
                }}
              >
                <div className="modal-dialog">
                  <div className="modal-content rounded-3 shadow-lg">
                    <div className="modal-header bg-primary deleteMgeHeader text-white">
                      <h5 className="modal-title">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        Confirm {capitalizeFirstLetter(userAction)}
                      </h5>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={closeModal}
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body text-center">
                      <p className="text-secondary modal-body-desc">
                        Are you sure you want to {userAction} this user? <br />
                        {/* <strong>This action cannot be undone.</strong> */}
                      </p>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                      <button
                        type="button"
                        className="btn btn-secondary px-4 deleteNoBtn"
                        onClick={closeModal}
                        style={{ borderRadius: "8px" }}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger px-4 deleteYesBtn"
                        onClick={confirmDelete}
                        style={{ borderRadius: "8px" }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className={`modal fade ${showUploadModal ? "show" : ""}`}
            tabIndex="-1"
            style={{ display: showUploadModal ? "block" : "none" }}
            aria-hidden={!showUploadModal}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header bg-primary deleteMgeHeader text-white">
                  <h5 className="modal-title">Uploading Bulk User Details</h5>
                  {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowModal(false)} disabled={isDownloading}></button> */}
                </div>
                <div className="modal-body text-center">
                  <p>
                    Your bulk user upload is in progress. Please wait
                    patiently...
                  </p>
                  <div className="dot-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                {/* <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setShowModal(false)} disabled={isDownloading}>
                                      Close
                                    </button>
                                  </div> */}
              </div>
            </div>
          </div>

          {/* Overlay to close modal when clicking outside */}
          {showUploadModal && (
            <div
              className="modal-backdrop fade show"
              onClick={() => setShowUploadModal(false)}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
